<div class="loading" [ngClass]="{'visible': loading.isLoading, 'hidden': !loading.isLoading }">
    <img src="assets/svg/puff.svg" />
</div>